import { SharedService } from 'src/app/shared/data/shared.service';
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideoBackgroundComponent } from 'src/app/shared/ui-common/video-background/video-background.component';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-feature-booking',
  imports: [CommonModule, VideoBackgroundComponent],
  templateUrl: './feature-booking.component.html',
  styleUrl: './feature-booking.component.scss',
})
export class FeatureBookingComponent implements OnInit {
  text = 'Loading';
  error = null;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private sharedService: SharedService
  ) {}

  ngOnInit(): void {
    const token = this.activatedRoute.snapshot.paramMap.get('token') ?? '';

    if (!token) {
      this.router.navigate(['/login']);

      return;
    }

    this.sharedService
      .fetchBookingtData(token)
      .then((response: { url: string }) => {
        const url = response?.url;

        if (url) {
          window.location.href = url;
        }
      })
      .catch((errorResponse: HttpErrorResponse) => {
        this.text = 'Ooops';
        this.error = errorResponse.error;
      });
  }
}
